export default __webpack_public_path__ + "static/media/economikavIEE.ad0afbd1.pdf";